export const layout = [
  {
    name: 'Base',
    objects: [
      {
        name: 'back',
        type: 'Image',
        width: 2320,
        height: 1480,
        resize: true,
        scale: 1.21,
        images: ['images/init/back.jpeg'],
        orientation: {
          land: {
            x: -200,
            y: -200,
          },
        },
      },
      {
        name: 'back-p',
        type: 'Image',
        width: 3009.72,
        height: 1920,
        resize: true,
        scale: 1.57,
        images: ['images/init/back.jpeg'],
        orientation: {
          port: {
            x: -964.86,
            y: 0,
          },
        },
      },
      {
        name: 'frame',
        type: 'Image',
        width: 2201,
        height: 1327,
        scale: 1.15,
        images: ['images/main/background/slot-box-l.png'],
        orientation: {
          land: {
            x: -139,
            y: -55,
          },
        },
      },
      {
        name: 'framep',
        type: 'Image',
        width: 1346,
        height: 1915,
        scale: 1,
        images: ['images/main/background/slot-box-p.png'],
        orientation: {
          port: {
            x: -132,
            y: 205,
          },
        },
      },
      {
        name: 'a',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        spine: 'animations/spine/back/land/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -8,
            scale: 1,
          },
        },
      },
      {
        name: 'a-p',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        spine: 'animations/spine/back/port/skeleton.json',
        orientation: {
          port: {
            x: 12,
            y: 0,
            scale: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'LinesEntity',
    objects: [
      {
        name: 'container',
        type: 'LinesContainer',
        x: 280,
        y: -1,
        width: 840,
        height: 810,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 282.53,
        y: 2.33,
        width: 834.47,
        height: 804.67,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 259.24,
        y: 135.94,
        scale: 1,
      },
      port: {
        x: -148,
        y: 463,
        scale: 1,
      },
    },
  },
  {
    name: 'ReelsEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'Reel',
        x: 280,
        y: -1,
        width: 280,
        height: 810,
      },
      {
        name: 'reel-1',
        type: 'Reel',
        x: 560,
        y: -1,
        width: 280,
        height: 810,
      },
      {
        name: 'reel-2',
        type: 'Reel',
        x: 840,
        y: -1,
        width: 280,
        height: 810,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 280,
        y: -1,
        width: 840,
        height: 810,
      },
      {
        name: 'swipe',
        type: 'SpinSwipeButton',
        x: 280,
        y: -1,
        width: 840,
        height: 810,
        alpha: '0',
        runtime: { platform: 'mobile,tablet' },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 259.24,
        y: 128.94,
        scale: 1,
      },
      port: {
        x: -148,
        y: 463,
        scale: 1,
      },
    },
  },
  {
    name: 'SymbolValueEntity',
    objects: [
      {
        name: 'symbol-value',
        type: 'SymbolValuePopup',
        x: 0,
        y: 0,
        width: '280',
        height: '270',
        color: '#edde4b',
        texture: 'SymbolValueBack',
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 539.24,
        y: 134.94,
        scale: 1,
      },
      port: {
        x: 126,
        y: 455,
        scale: 1.01,
      },
    },
  },
  {
    name: 'UIFrameEntity',
    objects: [
      {
        name: 'frame',
        type: 'NineSlicePlane',
        width: 10,
        height: 100,
        from: 'atlases/footer.png',
        orientation: {
          land: {
            x: -1500,
            y: 914,
            v: 1,
          },
        },
      },
      {
        name: 'frameP',
        type: 'NineSlicePlane',
        width: 10,
        height: 400,
        from: 'atlases/footer.png',
        orientation: {
          port: {
            x: -1000,
            y: 1700,
            v: 1,
          },
        },
      },
      {
        name: 'net',
        type: 'NineSlicePlane',
        width: 10,
        height: 100,
        from: 'atlases/net-land.png',
        orientation: {
          land: {
            x: -1500,
            y: 1000,
            v: 1,
          },
        },
      },
      {
        name: 'netFrameP',
        type: 'NineSlicePlane',
        width: 10,
        height: 193.94,
        from: 'atlases/net-port.png',
        orientation: {
          port: {
            x: -998.94,
            y: 1875,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'WinAnimationEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -422.91,
            y: -0.06,
          },
        },
      },
      {
        name: 'bigwins',
        type: 'WinSpine',
        width: 1920,
        height: 1080,
        scale: 0.65,
        orientation: {
          land: {
            x: 336,
            y: 149,
            scale: 0.65,
          },
          port: {
            x: -2.91,
            y: 543.12,
            scale: 0.57,
          },
        },
      },
      {
        name: 'you-win-big',
        type: 'WinText',
        width: 1489.92,
        height: 127,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 150,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1489.92,
        },
        orientation: {
          land: {
            x: 203.22,
            y: 789.73,
          },
          port: {
            x: -221.69,
            y: 1260.67,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'TextLineEntity',
    objects: [
      {
        name: 'line-win-text',
        type: 'LineWinText',
        width: 1399.83,
        height: 203.24,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 175,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1399.83,
        },
        orientation: {
          land: {
            x: 261.66,
            y: 417.51,
          },
          port: {
            x: -159.4,
            y: 748.05,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'Header',
    objects: [
      {
        name: 'logo',
        type: 'Image',
        width: 1058,
        height: 155,
        scale: 1,
        images: ['images/main/logo/crazy-box.png'],
        orientation: {
          land: {
            x: 432,
            y: -20,
          },
          port: {
            x: 10,
            y: 280,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuBackEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'AutoMenuEntity',
    objects: [
      {
        name: 'loss-0',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 460,
            y: 590,
          },
          port: {
            x: 286.33,
            y: 778,
          },
        },
      },
      {
        name: 'autoselected',
        type: 'Image',
        width: 226,
        height: 103,
        scale: 1.03,
        images: ['images/icons/button-0.png'],
        orientation: {
          port: {
            x: 426.5,
            y: 403.33,
          },
          land: {
            x: 848.57,
            y: 237.66,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 719,
            y: 590,
          },
          port: {
            x: 550.33,
            y: 777,
          },
        },
      },
      {
        name: 'prevauto',
        type: 'DecreaseAutoButton',
        width: 42,
        height: 60,
        hitzone: 4,
        scale: 1.76,
        images: [
          'images/icons/bet-left-0.png',
          'images/icons/bet-left-1.png',
        ],
        orientation: {
          port: {
            x: 113.5,
            y: 430,
          },
          land: {
            x: 533.91,
            y: 257,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 975,
            y: 590,
          },
          port: {
            x: 289.67,
            y: 913,
          },
        },
      },
      {
        name: 'nextauto',
        type: 'IncreaseAutoButton',
        width: 40,
        height: 60,
        hitzone: 4,
        scale: 1.72,
        images: [
          'images/icons/bet-right-0.png',
          'images/icons/bet-right-1.png',
        ],
        orientation: {
          port: {
            x: 936.5,
            y: 432.5,
          },
          land: {
            x: 1346.75,
            y: 257,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 1234,
            y: 590,
          },
          port: {
            x: 552.33,
            y: 909,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 460,
            y: 820,
          },
          port: {
            x: 302.67,
            y: 1165,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 718,
            y: 820,
          },
          port: {
            x: 561,
            y: 1163,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 976,
            y: 820,
          },
          port: {
            x: 297.67,
            y: 1299.33,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 1234,
            y: 820,
          },
          port: {
            x: 557,
            y: 1299.33,
          },
        },
      },
      {
        name: 'win',
        type: 'AutoLimitSelectedText',
        width: 991.41,
        height: 70,
        text: 'winlimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 991.41,
        },
        orientation: {
          land: {
            x: 466.25,
            y: 724.33,
          },
          port: {
            x: 40.14,
            y: 1065.67,
          },
        },
      },
      {
        name: 'loss',
        type: 'AutoLimitSelectedText',
        width: 960.94,
        height: 70,
        text: 'losslimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960.94,
        },
        orientation: {
          port: {
            x: 63.73,
            y: 683,
          },
          land: {
            x: 470.16,
            y: 479.33,
          },
        },
      },
      {
        name: 'loss-0',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 460,
            y: 590,
          },
          port: {
            x: 285.33,
            y: 779.67,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 719,
            y: 590,
          },
          port: {
            x: 552.67,
            y: 780.33,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 975,
            y: 590,
          },
          port: {
            x: 288.67,
            y: 914.33,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 1234,
            y: 590,
          },
          port: {
            x: 553.33,
            y: 911,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 460,
            y: 820,
          },
          port: {
            x: 298,
            y: 1166,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 718,
            y: 820,
          },
          port: {
            x: 556,
            y: 1166,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 976,
            y: 820,
          },
          port: {
            x: 298,
            y: 1300,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 1235,
            y: 820,
          },
          port: {
            x: 556.67,
            y: 1301.33,
          },
        },
      },
      {
        name: 'autoplay',
        type: 'Text',
        width: 852,
        height: 56,
        text: 'autoHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 852,
        },
        orientation: {
          land: {
            x: 526,
            y: 58,
          },
          port: {
            x: 112,
            y: 186,
          },
        },
      },
      {
        name: 'number',
        type: 'Text',
        width: 866,
        height: 70,
        text: 'numberSpins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 866,
        },
        orientation: {
          land: {
            x: 526,
            y: 138,
          },
          port: {
            x: 112,
            y: 308,
          },
        },
      },
      {
        name: 'settings',
        type: 'Text',
        width: 858,
        height: 69,
        text: 'extendedSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 858,
        },
        orientation: {
          land: {
            x: 534,
            y: 383,
          },
          port: {
            x: 112,
            y: 560,
          },
        },
      },
      {
        name: 'auto-carousel',
        type: 'AutoCarousel',
        width: 226,
        height: 95,
        text: '2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 848.57,
            y: 237.67,
          },
          port: {
            x: 427.5,
            y: 409,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 110,
        height: 110,
        deselect: true,
        direction: true,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 1316,
            y: 68,
          },
          port: {
            x: 903.67,
            y: 197,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'BetEntity',
    objects: [
      {
        name: 'bet',
        type: 'Text',
        width: 942.67,
        height: 71.84,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 53,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 942.67,
        },
        orientation: {
          land: {
            x: 495.33,
            y: 89.51,
          },
          port: {
            x: 80,
            y: 325,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 110,
        height: 110,
        deselect: true,
        direction: true,
        hitzone: 1,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 1317,
            y: 60,
          },
          port: {
            x: 903.18,
            y: 330.18,
          },
        },
      },
      {
        name: 'field',
        type: 'BetField',
        width: 948.53,
        height: 713.81,
        numberOfButtons: 24,
        textPosX: 110,
        textPosY: 50,
        texture: 'button-0',
        orientation: {
          land: {
            x: 490.41,
            y: 210.68,
          },
          port: {
            x: 76.01,
            y: 493.83,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'PaytableEntity',
    objects: [
      {
        name: 'PaytableEntity-header-text',
        type: 'Text',
        x: 0,
        y: 43,
        width: 1920,
        height: 100,
        text: 'paytableHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 72,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-jackpot-describe-text',
        type: 'Text',
        x: 471,
        y: 493.83,
        width: 404,
        height: 100.33,
        context: { jackpot: true },
        text: 'jackpotPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 404,
        },
      },
      {
        name: 'PaytableEntity-free-spins-describe-text',
        type: 'Text',
        x: 1017,
        y: 495.5,
        width: 468,
        height: 100.33,
        context: { jackpot: true },
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 468,
        },
      },
      {
        name: 'PrevAutoPage',
        type: 'DecreasePageButton',
        x: 618,
        y: 930,
        width: 24,
        height: 34,
        hitzone: 2,
        scale: 1,
        images: [
          'images/main/paytable/bet-left-0.png',
          'images/main/paytable/bet-left-1.png',
        ],
      },
      {
        name: 'NextAutoPage',
        type: 'IncreasePageButton',
        x: 1275,
        y: 930,
        width: 24,
        height: 34,
        hitzone: 2,
        scale: 1,
        images: [
          'images/main/paytable/bet-right-0.png',
          'images/main/paytable/bet-right-1.png',
        ],
      },
      {
        name: 'AutoCaruselPage',
        type: 'PageCarousel',
        x: 1027,
        y: 930,
        width: 30,
        height: 30,
        scale: 1,
        images: [
          'images/main/paytable/dot-0.png',
          'images/main/paytable/dot-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 527.66,
        y: 147.46,
        width: 908.1,
        height: 739.22,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'x2',
        type: 'Image',
        x: 693.81,
        y: 239.52,
        width: 536.92,
        height: 471.43,
        scale: 0.87,
        images: ['images/main/logo/x2.png'],
      },
      {
        name: 'PaytableEntity-x2-describe-text',
        type: 'Text',
        x: 643.57,
        y: 717.1,
        width: 670.19,
        height: 115.97,
        text: 'symbolsLayoutPay',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 42,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 670.19,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 527.66,
        y: 147.46,
        width: 908.1,
        height: 739.22,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1212.38,
        y: 656.32,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 734,
        y: 652.32,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1212.38,
        y: 377.32,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 734,
        y: 379.32,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: 'E',
        type: 'Image',
        x: 1013.65,
        y: 575.2,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/E.png'],
      },
      {
        name: 'F',
        type: 'Image',
        x: 533,
        y: 574,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/F.png'],
      },
      {
        name: 'G',
        type: 'Image',
        x: 1011.65,
        y: 302.2,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/G.png'],
      },
      {
        name: 'H',
        type: 'Image',
        x: 530,
        y: 300,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/H.png'],
      },
      {
        name: 'E-3',
        type: 'PayoutText',
        x: 1280.79,
        y: 656.7,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'F-3',
        type: 'PayoutText',
        x: 802.8,
        y: 652.7,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'G-3',
        type: 'PayoutText',
        x: 1280.79,
        y: 377.37,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'H-3',
        type: 'PayoutText',
        x: 804.8,
        y: 379.37,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 527.66,
        y: 147.46,
        width: 908.1,
        height: 739.22,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 731.6,
        y: 653.75,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1213.59,
        y: 649.75,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1217.59,
        y: 374.92,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 735.6,
        y: 376.92,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: 'A',
        type: 'Image',
        x: 1012.86,
        y: 575.8,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/A.png'],
      },
      {
        name: 'B',
        type: 'Image',
        x: 531.84,
        y: 577.8,
        width: 194,
        height: 194,
        scale: 0.73,
        images: ['images/main/items/static/B.png'],
      },
      {
        name: 'C',
        type: 'Image',
        x: 1012.86,
        y: 304.8,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/C.png'],
      },
      {
        name: 'D',
        type: 'Image',
        x: 533.84,
        y: 304.8,
        width: 194,
        height: 194,
        scale: 0.71,
        images: ['images/main/items/static/D.png'],
      },
      {
        name: 'A-3',
        type: 'PayoutText',
        x: 1282,
        y: 648.8,
        width: 160,
        height: 43,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'B-3',
        type: 'PayoutText',
        x: 800.01,
        y: 652.8,
        width: 160,
        height: 43,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'C-3',
        type: 'PayoutText',
        x: 1286,
        y: 375.8,
        width: 160,
        height: 43,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'D-3',
        type: 'PayoutText',
        x: 804.01,
        y: 377.8,
        width: 160,
        height: 43,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 527.66,
        y: 147.46,
        width: 908.1,
        height: 739.22,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-lines-header-text',
        type: 'Text',
        x: -5.95,
        y: 133.06,
        width: 1920,
        height: 100.33,
        text: 'linesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-lines-describe-text',
        type: 'Text',
        x: 460.05,
        y: 682.56,
        width: 1020.1,
        height: 152.33,
        text: 'payPaytable',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 34,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1020.1,
        },
      },
      {
        name: '1l',
        type: 'Image',
        x: 545,
        y: 272,
        width: 167,
        height: 166,
        scale: 1,
        images: ['images/main/winlines/1.png'],
      },
      {
        name: '2l',
        type: 'Image',
        x: 879,
        y: 272,
        width: 167,
        height: 166,
        scale: 1,
        images: ['images/main/winlines/2.png'],
      },
      {
        name: '3l',
        type: 'Image',
        x: 1213,
        y: 272,
        width: 167,
        height: 166,
        scale: 1,
        images: ['images/main/winlines/3.png'],
      },
      {
        name: '4l',
        type: 'Image',
        x: 712,
        y: 479,
        width: 167,
        height: 167,
        scale: 1,
        images: ['images/main/winlines/4.png'],
      },
      {
        name: '5l',
        type: 'Image',
        x: 1046,
        y: 479,
        width: 167,
        height: 167,
        scale: 1,
        images: ['images/main/winlines/5.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'GameRulesEntity',
    objects: [
      {
        name: 'GameRulesEntity-text',
        type: 'Text',
        x: 525.17,
        y: 6.83,
        width: 869,
        height: 196,
        text: 'rulesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 80,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 869,
        },
      },
      {
        name: 'GameRulesEntity-about-game-text',
        type: 'Text',
        x: 671.17,
        y: 167.17,
        width: 576,
        height: 62.67,
        text: 'about',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 576,
        },
      },
      {
        name: 'GameRulesEntity-about-describe-text',
        type: 'Text',
        x: 506.83,
        y: 248.5,
        width: 913,
        height: 88.33,
        text: 'aboutDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 913,
        },
      },
      {
        name: 'GameRulesEntity-return-player-text',
        type: 'Text',
        x: 666.67,
        y: 384.18,
        width: 582.5,
        height: 62.67,
        text: 'return',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 582.5,
        },
      },
      {
        name: 'GameRulesEntity-return-player-describe-text',
        type: 'RtpText',
        x: 492.83,
        y: 431.84,
        width: 933,
        height: 105.33,
        text: 'returnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 933,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-text',
        type: 'Text',
        x: 668.17,
        y: 1027.18,
        width: 580.33,
        height: 62.67,
        text: 'howPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 580.33,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-describe-text',
        type: 'Text',
        x: 492.5,
        y: 1094.18,
        width: 933,
        height: 107.33,
        text: 'howPlayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 933,
        },
      },
      {
        name: 'GameRulesEntity-button-functions-text',
        type: 'Text',
        x: 671.5,
        y: 3005.97,
        width: 586.33,
        height: 62.67,
        text: 'buttonFunctions',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 586.33,
        },
      },
      {
        name: 'GameRulesEntity-spin-describe-text',
        type: 'Text',
        x: 518.33,
        y: 3466.47,
        width: 268.67,
        height: 129.33,
        text: 'spinDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 268.67,
        },
      },
      {
        name: 'GameRulesEntity-spin-text',
        type: 'Text',
        x: 541.66,
        y: 3358.47,
        width: 219.33,
        height: 59.67,
        text: 'spin',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 219.33,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-text',
        type: 'Text',
        x: 1186.83,
        y: 3358.97,
        width: 172.67,
        height: 43.67,
        text: 'betHeaderRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 172.67,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-describe-text',
        type: 'Text',
        x: 1136.83,
        y: 3466.97,
        width: 268.67,
        height: 106.67,
        text: 'betHeaderDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 268.67,
        },
      },
      {
        name: 'GameRulesEntity-menu-text',
        type: 'Text',
        x: 620.83,
        y: 3638.97,
        width: 800,
        height: 59.67,
        text: 'menu',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-home-text',
        type: 'Text',
        x: 620.83,
        y: 3755.97,
        width: 800,
        height: 59.67,
        text: 'home',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-cashier-text',
        type: 'Text',
        x: 620.83,
        y: 3869.49,
        width: 800,
        height: 59.67,
        text: 'cashier',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-game-rules-text',
        type: 'Text',
        x: 620.83,
        y: 3985.49,
        width: 800,
        height: 59.67,
        text: 'gameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-paytable-text',
        type: 'Text',
        x: 620.83,
        y: 4102.89,
        width: 800,
        height: 59.67,
        text: 'paytable',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-additional-text',
        type: 'Text',
        x: -4.95,
        y: 4503.6,
        width: 1920,
        height: 62.67,
        text: 'additional',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-additional-describe-text',
        type: 'Text',
        x: -22.29,
        y: 4598.6,
        width: 1920,
        height: 45.17,
        text: 'additionalDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-generated-text',
        type: 'Text',
        x: -22.29,
        y: 4722.6,
        width: 1920,
        height: 62.67,
        text: 'generated',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-generated-describe-text',
        type: 'Text',
        x: -22.29,
        y: 4799.6,
        width: 1920,
        height: 59.17,
        text: 'generatedDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-game-settings-text',
        type: 'Text',
        x: 620.83,
        y: 4220.89,
        width: 800,
        height: 59.67,
        text: 'gameSettings',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-stop-header-text',
        type: 'Text',
        x: 836.67,
        y: 3358.97,
        width: 230,
        height: 43.67,
        text: 'startStopBtn',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 230,
        },
      },
      {
        name: 'GameRulesEntity-startstop-btn-describe',
        type: 'Text',
        x: 817.67,
        y: 3466.97,
        width: 268.67,
        height: 106.67,
        text: 'startStopBtnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 268.67,
        },
      },
      {
        name: 'GameRulesEntity-pays-text',
        type: 'Text',
        x: 436,
        y: 534.66,
        width: 1048,
        height: 62.67,
        text: 'pays',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays-describe-text',
        type: 'Text',
        x: 436,
        y: 611.34,
        width: 1048,
        height: 107.33,
        text: 'paysDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays2-describe-text',
        type: 'Text',
        x: 436,
        y: 699.34,
        width: 1048,
        height: 107.33,
        text: 'paysDescribeP',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays3-describe-text',
        type: 'Text',
        x: 436,
        y: 861.34,
        width: 1048,
        height: 107.33,
        text: 'paysDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays4-describe-text',
        type: 'Text',
        x: 436,
        y: 923.34,
        width: 1048,
        height: 107.33,
        text: 'paysDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-bet-text',
        type: 'Text',
        x: 436,
        y: 1382.58,
        width: 1048,
        height: 62.67,
        text: 'betGame',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-bet-describe-text',
        type: 'Text',
        x: 436,
        y: 1479.24,
        width: 1048,
        height: 83.33,
        text: 'betGameDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-startstop-text',
        type: 'Text',
        x: 436,
        y: 1618.94,
        width: 1048,
        height: 62.67,
        text: 'startStop',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 436,
        y: 1734.27,
        width: 1048,
        height: 110,
        text: 'startStopDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-startstop2-describe-text',
        type: 'Text',
        x: 436,
        y: 1846.27,
        width: 1048,
        height: 110,
        text: 'startStopDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-text',
        type: 'Text',
        x: 436,
        y: 1982.94,
        width: 1048,
        height: 62.67,
        text: 'desktopVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-describe-text',
        type: 'Text',
        x: 436,
        y: 2107.27,
        width: 1048,
        height: 110,
        text: 'desktopVersionDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-desktopv2-describe-text',
        type: 'Text',
        x: 436,
        y: 2217.27,
        width: 1048,
        height: 110,
        text: 'desktopVersionDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 436,
        y: 2635.54,
        width: 1048,
        height: 62.67,
        text: 'keyboard',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 436,
        y: 2747.2,
        width: 1048,
        height: 110,
        text: 'keyboardDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard3-describe-text',
        type: 'Text',
        x: 430.86,
        y: 2845.61,
        width: 1048,
        height: 77,
        text: 'keyboardDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'scroll',
        type: 'Graphics',
        x: 0,
        y: 0,
        width: 1920,
        height: 4939.99,
        alpha: 0,
      },
      {
        name: 'GameRulesEntity-mobile-describe-text',
        type: 'Text',
        x: 463,
        y: 2497.26,
        width: 1048,
        height: 80,
        text: 'leftHandModeDescription',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 1206,
        y: 3152.47,
        width: 140,
        height: 140,
        scale: 1,
        images: ['images/main/buttons/bet-button-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 579.4,
        y: 3152.47,
        width: 140,
        height: 140,
        scale: 0.54,
        images: ['images/main/buttons/spin-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 884,
        y: 3152.47,
        width: 140,
        height: 140,
        scale: 0.54,
        images: ['images/main/buttons/spin-1.png'],
      },
      {
        name: 'HISTORY - tap to view your latest game bets and payout',
        type: 'Text',
        x: 620,
        y: 4332.91,
        width: 800,
        height: 59.67,
        text: 'history',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 440.33,
        y: 1219.28,
        width: 1048,
        height: 80,
        context: { jackpot: false },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-feature-describe-text',
        type: 'Text',
        x: 438.89,
        y: 1278.41,
        width: 1084,
        height: 120.96,
        text: 'symbolsLayoutPay',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1084,
        },
      },
      {
        name: 'GameRulesEntity-mobile-text',
        type: 'Text',
        x: 436,
        y: 2374.28,
        width: 1048,
        height: 80,
        text: 'mobileVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/game_rules.png'],
      },
    },
  },
  {
    name: 'SettingsEntity',
    objects: [
      {
        name: 'settings',
        type: 'Text',
        width: 800,
        height: 56.67,
        text: 'settings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
        orientation: {
          land: {
            x: 560.65,
            y: 125.33,
          },
          port: {
            x: 128,
            y: 192,
          },
        },
      },
      {
        name: 'space',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        runtime: { platform: 'desktop' },
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 448,
          },
          port: {
            x: 803.32,
            y: 726.67,
          },
        },
      },
      {
        name: 'space',
        type: 'Text',
        width: 606.97,
        height: 55,
        runtime: { platform: 'desktop' },
        text: 'space',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 606.97,
        },
        orientation: {
          port: {
            x: 129.33,
            y: 735.83,
          },
          land: {
            x: 560,
            y: 448,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 352,
          },
          port: {
            x: 805.99,
            y: 592,
          },
        },
      },
      {
        name: 'sound',
        type: 'Text',
        width: 606.97,
        height: 55,
        text: 'sound',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 606.97,
        },
        orientation: {
          port: {
            x: 128,
            y: 596.17,
          },
          land: {
            x: 560,
            y: 352,
          },
        },
      },
      {
        name: 'left',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        runtime: { platform: 'mobile,tablet' },
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 448,
          },
          port: {
            x: 802,
            y: 726,
          },
        },
      },
      {
        name: 'left',
        type: 'Text',
        width: 606.97,
        height: 55,
        runtime: { platform: 'mobile,tablet' },
        text: 'leftHand',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 606.97,
        },
        orientation: {
          port: {
            x: 130,
            y: 742,
          },
          land: {
            x: 560,
            y: 448,
          },
        },
      },
      {
        name: 'turbo',
        type: 'Text',
        width: 658,
        height: 55,
        text: 'turboModeSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 658,
        },
        orientation: {
          land: {
            x: 560,
            y: 256,
          },
          port: {
            x: 122,
            y: 458,
          },
        },
      },
      {
        name: 'turbo',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 252,
          },
          port: {
            x: 800,
            y: 464,
          },
        },
      },
      {
        name: 'fps',
        type: 'Text',
        width: 658,
        height: 55,
        text: 'fps',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 658,
        },
        orientation: {
          land: {
            x: 560,
            y: 544,
          },
          port: {
            x: 130,
            y: 888,
          },
        },
      },
      {
        name: 'cheat',
        type: 'Text',
        width: 658,
        height: 55,
        context: { debug: true },
        text: 'cheat',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 658,
        },
        orientation: {
          land: {
            x: 560,
            y: 640,
          },
          port: {
            x: 130,
            y: 1034,
          },
        },
      },
      {
        name: 'cheat',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        context: { debug: true },
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 629,
          },
          port: {
            x: 803,
            y: 1034,
          },
        },
      },
      {
        name: 'fps',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 538,
          },
          port: {
            x: 803,
            y: 888,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuEntity',
    objects: [
      {
        name: 'menuhome',
        type: 'ImageButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: ['images/icons/menu-home.png'],
        orientation: {
          land: {
            x: 110,
            y: 140,
          },
          port: {
            x: 215,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menu-gamerules',
        type: 'RadioButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: [
          'images/icons/menu-info-0.png',
          'images/icons/menu-info-1.png',
        ],
        orientation: {
          land: {
            x: 110,
            y: 360,
          },
          port: {
            x: 475,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menu-paytable',
        type: 'RadioButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: [
          'images/icons/menu-paytable-0.png',
          'images/icons/menu-paytable-1.png',
        ],
        orientation: {
          land: {
            x: 110,
            y: 470,
          },
          port: {
            x: 605,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menucashier',
        type: 'ImageButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: ['images/icons/menu-cashier-1.png'],
        orientation: {
          land: {
            x: 110,
            y: 250,
          },
          port: {
            x: 345,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menu-settings',
        type: 'RadioButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: [
          'images/icons/menu-settings-0.png',
          'images/icons/menu-settings-1.png',
        ],
        orientation: {
          land: {
            x: 110,
            y: 580,
          },
          port: {
            x: 735,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menuhistory',
        type: 'ImageButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 1.5,
        scale: 1,
        images: ['images/icons/menu-history-1.png'],
        orientation: {
          land: {
            x: 110,
            y: 690,
          },
          port: {
            x: 865,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 100,
        height: 100,
        deselect: true,
        direction: true,
        hitzone: 1,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 100,
            y: 794,
          },
          port: {
            x: 53,
            y: 1550,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIRegularEntity',
    objects: [
      {
        name: 'spin',
        type: 'SpinButton',
        width: 256.67,
        height: 256.67,
        direction: true,
        scale: 0.99,
        images: [
          'images/icons/spin-0.png',
          'images/icons/spin-1.png',
        ],
        orientation: {
          land: {
            x: 1684.33,
            y: 406,
          },
          port: {
            x: 416.45,
            y: 1432,
            v: 1,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 135.67,
        height: 135.67,
        deselect: true,
        direction: true,
        hitzone: 1.5,
        scale: 0.97,
        images: [
          'images/icons/bet-button-0.png',
          'images/icons/bet-button-1.png',
        ],
        orientation: {
          port: {
            x: 231,
            y: 1527,
            v: 1,
          },
          land: {
            x: 1746.67,
            y: 698,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 100,
        height: 100,
        deselect: true,
        direction: true,
        hitzone: 3,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 100,
            y: 794,
          },
          port: {
            x: 53,
            y: 1551,
            v: 1,
          },
        },
      },
      {
        name: 'autostop',
        type: 'ImageButton',
        width: 140,
        height: 140,
        direction: true,
        scale: 0.89,
        images: ['images/icons/stop-autoplay.png'],
        orientation: {
          port: {
            x: 909,
            y: 1526,
            v: 1,
          },
          land: {
            x: 1735.66,
            y: 54,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 140,
        height: 140,
        deselect: true,
        direction: true,
        scale: 1,
        images: [
          'images/icons/auto-menu-0.png',
          'images/icons/auto-menu-1.png',
        ],
        orientation: {
          land: {
            x: 1745.33,
            y: 64,
          },
          port: {
            x: 909,
            y: 1526,
            v: 1,
          },
        },
      },
      {
        name: 'autospin-text',
        type: 'AutoCountText',
        width: 100,
        height: 100,
        direction: true,
        text: '10',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 1762.33,
            y: 482,
          },
          port: {
            x: 492.32,
            y: 1508,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'WinText',
        width: 412,
        height: 35,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 412,
        },
        orientation: {
          port: {
            x: 327,
            y: 1785,
            v: 1,
          },
          land: {
            x: 770,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-count',
        type: 'FreeBetLeft',
        width: 200,
        height: 35,
        text: '$5,00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 1405,
            y: 961,
            v: 1,
          },
          port: {
            x: 677.19,
            y: 1785,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'Text',
        width: 270,
        height: 35,
        text: 'win',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 270,
        },
        orientation: {
          port: {
            x: 396,
            y: 1737,
            v: 1,
          },
          land: {
            x: 837.79,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-text',
        type: 'FreeBetText',
        width: 270,
        height: 35,
        text: 'freeBetLeft',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 1364.23,
            y: 926,
            v: 1,
          },
          port: {
            x: 634.9,
            y: 1738.46,
            v: 1,
          },
        },
      },
      {
        name: 'sound-bg',
        type: 'Image',
        width: 140,
        height: 140,
        direction: true,
        scale: 1.04,
        images: ['images/underlay/circle-small.png'],
        orientation: {
          land: {
            x: 1744,
            y: 236,
          },
          port: {
            x: 706,
            y: 1526,
            v: 1,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 105.42,
        height: 90.36,
        direction: true,
        scale: 1.51,
        images: [
          'images/icons/sound-0.png',
          'images/icons/sound-1.png',
        ],
        orientation: {
          land: {
            x: 1761.11,
            y: 259.63,
          },
          port: {
            x: 722.26,
            y: 1550,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIGeneralEntity',
    objects: [
      {
        name: 'bet-name',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'right',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          land: {
            x: 1687,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'balance-name',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'balance',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          port: {
            x: 48,
            y: 1737,
            v: 1,
          },
          land: {
            x: 39.5,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value',
        type: 'BetText',
        width: 351.52,
        height: 35,
        text: '$ 2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 351.52,
        },
        orientation: {
          land: {
            x: 1534.15,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'balance-value',
        type: 'BalanceText',
        width: 428.65,
        height: 35,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 428.65,
        },
        orientation: {
          port: {
            x: 48,
            y: 1785,
            v: 1,
          },
          land: {
            x: 39.67,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'bet-name-p',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          port: {
            x: 848,
            y: 1737,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value-p',
        type: 'BetText',
        width: 350,
        height: 35,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 350,
        },
        orientation: {
          port: {
            x: 698,
            y: 1785,
            v: 1,
          },
        },
      },
      {
        name: 'timer-clock',
        type: 'TimerText',
        width: 100,
        height: 35,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 40,
            y: 1020,
            v: 1,
          },
          port: {
            x: 48,
            y: 1878,
            v: 1,
          },
        },
      },
      {
        name: 'timer-name',
        type: 'Text',
        width: 149.1,
        height: 35,
        text: 'timeElapsed',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 149.1,
        },
        orientation: {
          land: {
            x: 150,
            y: 1020,
            v: 1,
          },
          port: {
            x: 150.35,
            y: 1878,
            v: 1,
          },
        },
      },
      {
        name: 'net-balance',
        type: 'NetPosition',
        width: 163.89,
        height: 35,
        text: '',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 163.89,
        },
        orientation: {
          land: {
            x: 1721,
            y: 1020,
            v: 1,
          },
          port: {
            x: 880,
            y: 1878,
            v: 1,
          },
        },
      },
      {
        name: 'net-name',
        type: 'Text',
        width: 150.35,
        height: 35,
        text: 'netPosition',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 150.35,
        },
        orientation: {
          land: {
            x: 1568,
            y: 1020,
            v: 1,
          },
          port: {
            x: 726,
            y: 1878,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreebetEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'bg',
        type: 'Image',
        width: 740,
        height: 510,
        scale: 1,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          land: {
            x: 590,
            y: 280.48,
          },
        },
      },
      {
        name: 'bg-p',
        type: 'Image',
        width: 740,
        height: 510,
        scale: 1,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          port: {
            x: 190,
            y: 630.71,
          },
        },
      },
      {
        name: 'FB-CLOSE',
        type: 'RadioButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 849.67,
            y: 642.33,
          },
          port: {
            x: 446.57,
            y: 986.43,
          },
        },
      },
      {
        name: 'text',
        type: 'Text',
        width: 224.83,
        height: 103.17,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 224.83,
        },
        orientation: {
          land: {
            x: 849.33,
            y: 646,
          },
          port: {
            x: 447.58,
            y: 989.72,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'FreeBetWinText',
        width: 741.67,
        height: 148.85,
        text: 'freeBetTotalWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 65,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 741.67,
        },
        orientation: {
          land: {
            x: 587.83,
            y: 449.58,
          },
          port: {
            x: 189.88,
            y: 793.43,
          },
        },
      },
      {
        name: 'fb-end-popup',
        type: 'PopupText',
        width: 733.14,
        height: 158.28,
        text: 'freeBetEnd',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 733.14,
        },
        orientation: {
          land: {
            x: 594.76,
            y: 279.53,
          },
          port: {
            x: 190.57,
            y: 635.15,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'FreeBetCountText',
        width: 741.67,
        height: 148.85,
        text: 'freeBetsCount',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 65,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 741.67,
        },
        orientation: {
          land: {
            x: 587.83,
            y: 449.58,
          },
          port: {
            x: 189.88,
            y: 797,
          },
        },
      },
      {
        name: 'fb-add-popup',
        type: 'PopupText',
        width: 741.67,
        height: 148.85,
        text: 'congrats',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 741.67,
        },
        orientation: {
          land: {
            x: 589.67,
            y: 278.65,
          },
          port: {
            x: 191.86,
            y: 624.56,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'IntroScreenEntity',
    objects: [
      {
        name: 'splbgr',
        type: 'ImageButton',
        width: 2320,
        height: 1480,
        resize: true,
        scale: 1.21,
        images: ['images/init/back.jpeg'],
        orientation: {
          land: {
            x: -200,
            y: -200,
          },
        },
      },
      {
        name: 'splbgr1',
        type: 'Image',
        width: 3009.74,
        height: 1920,
        resize: true,
        scale: 1.57,
        images: ['images/init/back.jpeg'],
        orientation: {
          port: {
            x: -964.87,
            y: 0,
          },
        },
      },
      {
        name: 'sym',
        type: 'Image',
        width: 1378,
        height: 380,
        scale: 1,
        images: ['images/splash/sym-l.png'],
        orientation: {
          land: {
            x: 268,
            y: 64,
          },
        },
      },
      {
        name: 'symp',
        type: 'Image',
        width: 893,
        height: 380,
        scale: 1,
        images: ['images/splash/sym-p.png'],
        orientation: {
          port: {
            x: 101,
            y: 251,
          },
        },
      },
      {
        name: 'gl',
        type: 'Image',
        width: 1265,
        height: 236,
        scale: 1,
        images: ['images/splash/logo-l.png'],
        orientation: {
          land: {
            x: 324,
            y: 405,
          },
        },
      },
      {
        name: 'glp',
        type: 'Image',
        width: 775,
        height: 398,
        scale: 1,
        images: ['images/splash/logo-p.png'],
        orientation: {
          port: {
            x: 151,
            y: 706,
          },
        },
      },
      {
        name: '33',
        type: 'Image',
        width: 387,
        height: 218,
        scale: 1,
        images: ['images/splash/3x3.png'],
        orientation: {
          land: {
            x: 768,
            y: 596,
          },
          port: {
            x: 350,
            y: 1074,
          },
        },
      },
      {
        name: 'close',
        type: 'GraphicsButton',
        width: 1920,
        height: 1920,
        alpha: 0,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-text',
        type: 'Text',
        width: 1920,
        height: 117.02,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 60,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
        orientation: {
          land: {
            x: 2.53,
            y: 880.67,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-port-text',
        type: 'Text',
        width: 1080,
        height: 125.68,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 60,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1080,
        },
        orientation: {
          port: {
            x: 5.75,
            y: 1480.25,
          },
        },
      },
      {
        name: 'underloader',
        type: 'Image',
        width: 676,
        height: 24,
        scale: 1,
        images: ['../clover/images/splash/loader/loader-gray.png'],
        orientation: {
          land: {
            x: 624.67,
            y: 923.54,
          },
          port: {
            x: 208.75,
            y: 1528.46,
          },
        },
      },
      {
        name: 'loaderline',
        type: 'Loader',
        width: 666,
        height: 16,
        scale: 1,
        images: ['../clover/images/splash/loader/loader-progress.png'],
        orientation: {
          land: {
            x: 629.95,
            y: 927.24,
          },
          port: {
            x: 213.75,
            y: 1532.52,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'SoundPopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'sound-back',
        type: 'Image',
        width: 672,
        height: 346.84,
        scale: 1.08,
        images: ['images/underlay/soundBack.png'],
        orientation: {
          land: {
            x: 618,
            y: 358.67,
          },
          port: {
            x: 217,
            y: 754,
          },
        },
      },
      {
        name: 'sound-1',
        type: 'ImageButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 708,
            y: 499,
          },
          port: {
            x: 284,
            y: 897,
          },
        },
      },
      {
        name: 'sound-0',
        type: 'ImageButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 986,
            y: 499,
          },
          port: {
            x: 608,
            y: 896,
          },
        },
      },
      {
        name: 'enable-sound',
        type: 'Text',
        width: 698.67,
        height: 76.33,
        text: 'soundQuestion',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 698.67,
        },
        orientation: {
          land: {
            x: 600,
            y: 399,
          },
          port: {
            x: 215,
            y: 782.67,
          },
        },
      },
      {
        name: 'sound-yes',
        type: 'Text',
        width: 109,
        height: 105,
        text: 'soundYes',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109,
        },
        orientation: {
          land: {
            x: 800,
            y: 500,
          },
          port: {
            x: 355.33,
            y: 896,
          },
        },
      },
      {
        name: 'sound-no',
        type: 'Text',
        width: 109,
        height: 105,
        text: 'soundNo',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109,
        },
        orientation: {
          land: {
            x: 1070,
            y: 500,
          },
          port: {
            x: 689.33,
            y: 898,
          },
        },
      },
      {
        name: 'sound-yes-pic',
        type: 'Image',
        width: 48.05,
        height: 53.04,
        scale: 0.81,
        images: ['images/icons/sound-1.png'],
        orientation: {
          land: {
            x: 734.17,
            y: 524.15,
          },
          port: {
            x: 304.33,
            y: 920.83,
          },
        },
      },
      {
        name: 'sound-no-pic',
        type: 'Image',
        width: 70,
        height: 60,
        scale: 1,
        images: ['images/icons/sound-0.png'],
        orientation: {
          land: {
            x: 1010.33,
            y: 522,
          },
          port: {
            x: 633,
            y: 919.33,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'PopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'image',
        type: 'PopupButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 836.33,
            y: 649,
          },
          port: {
            x: 443,
            y: 940,
          },
        },
      },
      {
        name: 'text',
        type: 'PopupButton',
        width: 224.83,
        height: 103.17,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 224.83,
        },
        orientation: {
          land: {
            x: 836,
            y: 652.67,
          },
          port: {
            x: 444.01,
            y: 943.29,
          },
        },
      },
      {
        name: 'body',
        type: 'PopupText',
        width: 951,
        height: 336.85,
        text: 'NO INTERNET CONNECTION.\nPLEASE CHECK YOUR CONNECTION\nAND RELOAD THE GAME TO CONTINUE',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 951,
        },
        orientation: {
          land: {
            x: 483,
            y: 202.65,
          },
          port: {
            x: 74.01,
            y: 560.27,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'FullscreenEntity',
    objects: [
      {
        name: 'fullscreen',
        type: 'GraphicsButton',
        width: 1920,
        height: 1920,
        alpha: 0.5,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'tapa',
        type: 'Image',
        width: 252,
        height: 425,
        runtime: {
          os: 'android',
          platform: 'mobile,tablet',
        },
        scale: 1,
        images: ['images/icons/fullscreen-1.png'],
        orientation: {
          land: {
            x: 847.33,
            y: 328,
          },
          port: {
            x: 427,
            y: 745.67,
          },
        },
      },
      {
        name: 'tap',
        type: 'AnimationSpine',
        width: 329,
        height: 471,
        runtime: {
          os: 'ios',
          platform: 'mobile,tablet',
        },
        spine: 'animations/spine/fullscreen/skeleton.json',
        orientation: {
          land: {
            x: 796,
            y: 295,
            scale: 1,
          },
          port: {
            x: 394,
            y: 715,
            scale: 1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'LoadingEntity',
    objects: [
      {
        name: 'logoanim',
        type: 'LogoSpine',
        width: 1920,
        height: 1080,
        spine: 'brand/anim/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: -820,
            y: 400,
          },
        },
      },
    ],
    properties: { parentGroup: 'INIT' },
  },
  {
    name: 'UIGeneralOverlayEntity',
    objects: [
      {
        name: 'intro-clock-l',
        type: 'ClockText',
        width: 109.53,
        height: 40.8,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 29,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109.53,
        },
        orientation: {
          land: {
            x: 1761.62,
            y: 9.06,
            v: -1,
          },
        },
      },
      {
        name: 'intro-clock-p',
        type: 'ClockText',
        width: 93.67,
        height: 31.67,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 29,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 93.67,
        },
        orientation: {
          port: {
            x: 981.55,
            y: 6.84,
            h: 1,
            v: -1,
          },
        },
      },
      {
        name: 'game-name',
        type: 'Text',
        width: 466.23,
        height: 29.59,
        alpha: 0.5,
        force: false,
        text: 'gameName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 13.53,
            y: 0,
            h: -1,
            v: -1,
          },
          port: {
            x: 23.8,
            y: 8.82,
            h: -1,
            v: -1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
]
